'use client'

import React, { useState } from 'react'
import Image from 'next/image'
import { LogoType } from '@/lib/models/components/ourPartnersLogos.types'
import { IconType } from '@/lib/ui-kit/components/ui/Icon.types'
import { ButtonIconText } from '@/lib/ui-kit/components/ui/ButtonIconText.component'
import { ButtonType } from '@/lib/models/components/buttonLink.types'

export const Logos = ({
  apiAssetsUrl,
  logos,
}: {
  apiAssetsUrl?: string
  logos: LogoType[]
}) => {
  const [visibleCount, setVisibleCount] = useState(12)

  const visibleLogos = logos.slice(0, visibleCount)

  const handleSeeMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 6, logos.length))
  }

  return (
    <div className="grid grid-cols-1 gap-y-10 bg-gray-200 xl:grid-cols-6">
      {Boolean(visibleLogos.length) &&
        visibleLogos.map((data, index) => (
          <div className="flex items-center justify-center" key={index}>
            {data?.link ? (
              <a href={data.link} target="_blank" rel="noopener noreferrer">
                <Image
                  className="max-w-[125px]"
                  src={`${apiAssetsUrl || ''}${data?.url}`}
                  width={data?.width}
                  height={data?.height}
                  alt={data?.alternativeText ?? "partner's logo"}
                />
              </a>
            ) : (
              <Image
                className="max-w-[125px]"
                src={`${apiAssetsUrl || ''}${data?.url}`}
                width={data?.width}
                height={data?.height}
                alt={data?.alternativeText ?? "partner's logo"}
              />
            )}
          </div>
        ))}
      {visibleLogos.length < logos.length && (
        <div className="col-span-6 flex items-center justify-center">
          <div onClick={handleSeeMore}>
            <ButtonIconText
              variant={ButtonType.PRIMARY}
              iconType={IconType.arrow_down}
            >
              See more
            </ButtonIconText>
          </div>
        </div>
      )}
    </div>
  )
}
